import { render, staticRenderFns } from "./ProdEditBomChild.vue?vue&type=template&id=6adf3689&scoped=true&"
import script from "./ProdEditBomChild.vue?vue&type=script&lang=js&"
export * from "./ProdEditBomChild.vue?vue&type=script&lang=js&"
import style0 from "./ProdEditBomChild.vue?vue&type=style&index=0&id=6adf3689&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf3689",
  null
  
)

export default component.exports